module.exports = __webpack_public_path__ + "static/media/tractor.7aa3035e.svg";